export const siteConfig = {
  title: "FED Docs",
  copyright: "Copyright © 厦门建发信息技术有限公司",
  showVersion: false, // 是否显示多版本菜单
  customHome: false, // 是否使用定制首页（/docs/Home.vue）
  showSimulator: false // 是否显示手机 iFrame（展示移动端组件 Demo）
}
